import * as Yup from "yup";

const desdobrarTituloValidator = Yup.object().shape({
  tipoDesdobramento: Yup.string().required("Tipo de Desdobramento"),
  qtdParcelas: Yup.string().required("Quantidade de Dias"),
  intervaloDias: Yup.number().required("Intervalo de Dias"),
});

export default desdobrarTituloValidator;
